module.exports = __webpack_public_path__ + "static/media/malphos_1000ce.1f0cb00f.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/tomate/climasense/mosca_blanca_tomate/curativa/malphos_1000ce.png
// module id = 2392
// module chunks = 3